<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'bankAccountEdit',
    components: {
      baseEdit,
    },
  };
</script>
